<ol class="container" *ngIf="eventsList?.length">
  <li>
    <h2 mat-dialog-title>Join Group</h2>
    <!--  <div fxLayout="column">
      <div style="margin-bottom: 5%;">
        <label>Enter Meeting Id</label>
        <input [(ngModel)]="meetingId" placeholder="e.g XXX-XXX-XXX" class="form-control">
      </div>
    </div>
    <p class="cus-content">OR</p>-->

    <mat-list role="list">
      <ng-container *ngIf="eventsList?.length">
        <mat-list-item role="listitem" *ngFor="let item of eventsList">
          <div mat-line [title]="item.description">{{item.description | titlecase}}</div>
          <div mat-line [title]="item.hostFirstName"> Created by: {{item.hostFirstName | titlecase }} </div>
          <button style="background: #de1b36 !important; color: white !important;" mat-button class="btn-join-grp" color="primary" (click)="joinGroupEvent(item)"  *ngIf="!eventSelected">Join</button>
          <button mat-button class="btn-join-grp" color="primary"  *ngIf="eventSelected"><mat-spinner [diameter]="20" strokeWidth="3" *ngIf="eventSelected"></mat-spinner></button>
          

        </mat-list-item>
      </ng-container>
      <mat-list-item role="listitem" *ngIf="!eventsList?.length">No Groups Available</mat-list-item>
    </mat-list>

    <!-- <div class="cus-btn-section">
      <button mat-raised-button color="primary" (click)="joinGroup()"
        style="margin-left: 20px;background: #de1b36;">Join Group</button>
      <button mat-raised-button color="primary" style="margin-left: 20px;background: #de1b36;"
        (click)="closeDialog()">Cancel</button>
    </div>-->
  </li>
</ol>